import React, { FCC } from 'react';
import { Form, IFormProps } from '../Form';
import { IWizardStepPropsPrivate } from './types';
import { WizardStep } from './WizardStep';

type IFormPropsSubset = Omit<IFormProps<{}>, 'onSubmit'>;

export interface IWizardFormStepProps extends IFormPropsSubset, IWizardStepPropsPrivate {}

export const WizardFormStep: FCC<IWizardFormStepProps> = (props) => {
  const {
    id,
    ignore,
    nextLabel,
    previousLabel,
    saveLabel,
    sidebarLabel,
    type,
    _beforeTransition,
    _isActive,
    _meta,
    _onClose,
    _onComplete,
    _onNext,
    _onPrevious,
    _onRef,
    _onSave,
    _width,
    ...formProps
  } = props;
  const stepProps = {
    _beforeTransition,
    _isActive,
    _meta,
    _onClose,
    _onComplete,
    _onNext,
    _onPrevious,
    _onRef,
    _onSave,
    _width,
    id,
    ignore,
    nextLabel,
    previousLabel,
    saveLabel,
    sidebarLabel,
  };
  return (
    <WizardStep {...stepProps} type={'form'}>
      <Form
        onSubmit={(values) => ''} // this is a placeholder that will be overridden later
        {...formProps}
      />
    </WizardStep>
  );
};

export default WizardFormStep;
